import React from "react";

export default function InterdicaoViaFields({
  Section,
  DropdownField,
  DateDropdownField,
  form,
  onChange,
  sbOptions,
  motivoOptions,
  nivelAcionamentoOptions,
  kmHint,
  kmError,
}) {
  return (
    <>
      <Section title="Operação">
        <div className="interdNova-grid interdNova-grid--3">
          <DateDropdownField
            label="Data"
            value={form.viaData}
            onChange={onChange("viaData")}
          />

          <label className="interdNova-field">
            <span>Horário início</span>
            <input
              type="time"
              value={form.viaHorarioInicio}
              onChange={onChange("viaHorarioInicio")}
            />
          </label>

          <DropdownField
            label="Seção de Bloqueio"
            value={form.sb}
            onChange={onChange("sb")}
            options={sbOptions}
            searchable
            searchInline
            preferredDirection="down"
            searchPlaceholder="Digite a seção de bloqueio"
            placeholder="Selecione a seção"
          />

          <label className="interdNova-field">
            <span>SUB</span>
            <input
              type="text"
              value={form.sub}
              onChange={onChange("sub")}
              placeholder="Ex.: SUB 12"
            />
          </label>

          <label className="interdNova-field">
            <span>KM de trabalho</span>
            <input
              type="text"
              className={kmError ?"interdNova-inputInvalid" : ""}
              value={form.kmInicial}
              onChange={onChange("kmInicial")}
              placeholder="125,300"
              aria-invalid={Boolean(kmError)}
            />
            {kmError ?(
              <small className="interdNova-fieldError">{kmError}</small>
            ) : kmHint ?(
              <small className="interdNova-fieldHint">{kmHint}</small>
            ) : null}
          </label>
        </div>
      </Section>

      <Section title="Previsão">
        <div className="interdNova-grid interdNova-grid--3">
          <DropdownField
            label="Tem previsão?"
            value={form.temPrevisao}
            onChange={onChange("temPrevisao")}
            preferredDirection="down"
            options={[
              { value: "nao", label: "Não" },
              { value: "sim", label: "Sim" },
            ]}
          />

          {form.temPrevisao === "sim" ?(
            <>
              <DateDropdownField
                label="Data fim"
                value={form.dataFim}
                onChange={onChange("dataFim")}
              />

              <label className="interdNova-field">
                <span>Hora fim</span>
                <input type="time" value={form.horaFim} onChange={onChange("horaFim")} />
              </label>
            </>
          ) : null}
        </div>
      </Section>

      <Section title="Identificação">
        <div className="interdNova-grid interdNova-grid--3">
          <label className="interdNova-field">
            <span>Identificador</span>
            <input
              type="text"
              value={form.identificador}
              onChange={onChange("identificador")}
              placeholder="Ex.: INT-2045 ou deixe em branco"
            />
          </label>

          <label className="interdNova-field">
            <span>Acionamento</span>
            <input
              type="text"
              value={form.acionamento}
              onChange={onChange("acionamento")}
              placeholder="Ex.: Solicitação do CCO"
            />
          </label>

          <DropdownField
            label="Nível de Acionamento"
            value={form.nivelAcionamento}
            onChange={onChange("nivelAcionamento")}
            options={nivelAcionamentoOptions}
            placeholder="Selecione o nível"
            preferredDirection="down"
          />

          <DropdownField
            label="Motivo"
            value={form.motivo}
            onChange={onChange("motivo")}
            options={motivoOptions}
            placeholder="Selecione o motivo"
            searchable
            searchInline
            preferredDirection="down"
            searchPlaceholder="Digite o motivo"
            menuMaxHeight={164}
          />

          <label className="interdNova-field interdNova-field--full">
            <span>Observação</span>
            <textarea
              rows="3"
              className="interdNova-observacao"
              value={form.observacao}
              onChange={onChange("observacao")}
              placeholder="Complemento livre da interdição"
            />
          </label>
        </div>
      </Section>
    </>
  );
}
